import { useCallback } from 'react';

const useActions = ({ setVisible, setEditAlert, setAlertToDelete, setConfirmationVisible }) => {
  const onCancel = useCallback(() => {
    setVisible(false);
    setEditAlert({});
  }, [setVisible, setEditAlert]);

  const onCancelConfirmation = useCallback(() => {
    setAlertToDelete({});
    setConfirmationVisible(false);
  }, [setAlertToDelete, setConfirmationVisible]);

  const onDelete = useCallback(
    (alert) => {
      setConfirmationVisible(true);
      setAlertToDelete(alert);
    },
    [setConfirmationVisible, setAlertToDelete],
  );

  const onEdit = useCallback(
    (alert) => {
      setVisible(true);
      setEditAlert(alert);
    },
    [setVisible, setEditAlert],
  );

  const onCreate = useCallback(() => {
    setVisible(true);
    setEditAlert({});
  }, [setVisible, setEditAlert]);

  return {
    onCancel,
    onCancelConfirmation,
    onDelete,
    onEdit,
    onCreate,
  };
};

export default useActions;
